import React, { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

export const Header = () => {
  const navHide = useCallback(() => {
    let newNav = document.getElementById("newNav");
    let nav = document.getElementById("mainNav");
    if (newNav && nav) {
      if (window.innerWidth < 991) {
        newNav.classList.add("d-none");
        nav.style.opacity = "1";
        nav.classList.remove("d-none");
      } else {
        newNav.classList.remove("d-none");
        nav.style.opacity = "0";
      }
    }
  }, []);

  const disNav = useCallback(() => {
    let nav = document.getElementById("mainNav");
    let newNav = document.getElementById("newNav");

    if (nav && newNav && window.innerWidth > 991) {
      if (window.scrollY < 25) {
        nav.style.opacity = "0";
        nav.classList.add("d-none");
        newNav.classList.remove("d-none");
      } else {
        nav.classList.remove("d-none");
        newNav.classList.add("d-none");
        setTimeout(() => {
          nav.style.opacity = "1";
        }, 50);
      }
    }
  }, []);

  const fixNav = useCallback(() => {
    let navLogo = document.getElementById("navLogo");
    if (navLogo) {
      if (window.scrollY > 10) {
        navLogo.classList.remove("d-none");
      } else {
        navLogo.classList.add("d-none");
      }
    }
  }, []);

  const handleClickOutside = useCallback((e) => {
    const mainNav = document.getElementById("mainNav");
    const navToggler = document.getElementById("navToggler");

    if (mainNav && navToggler && window.innerWidth < 991) {
      if (!mainNav.contains(e.target)) {
        if (!navToggler.classList.contains("collapsed")) {
          navToggler.click();
        }
      }
    }
  }, []);

  useEffect(() => {
    // Add event listeners
    window.addEventListener("scroll", fixNav);
    window.addEventListener("scroll", disNav);
    window.addEventListener("resize", navHide);
    window.addEventListener("load", navHide);
    window.addEventListener("click", handleClickOutside);

    // Initial setup
    navHide();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", fixNav);
      window.removeEventListener("scroll", disNav);
      window.removeEventListener("resize", navHide);
      window.removeEventListener("load", navHide);
      window.removeEventListener("click", handleClickOutside);
    };
  }, [fixNav, disNav, navHide, handleClickOutside]);

  return (
    <>
      {/* Removed the <Header /> self-rendering */}
      <div className="newNav" id="newNav">
        <div className="newNav-cont d-lg-flex d-md-flex d-xl-flex align-items-center justify-content-center d-none shadow">
          <div className="logoLeft col-2">
            <img src="assets/images/msq_logo.png" alt="MenteSquare Logo" />
          </div>
          <div className="listRight col-8">
            <ul className="d-flex list-unstyled justify-content-center">
              <li className="nav-item">
                <Link className="nav-link" to={"/home"}>
                  Home
                </Link>
              </li>
              <li>
                <Link className="nav-link" to={"/LDInterventions"}>
                  OD Interventions
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/gyaan-guides"}>
                  Gyaan Guides
                </Link>
              </li>
              <li>
                <Link className="nav-link" to={"/MentoringPage"}>
                  Mentoring
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/BrandingPage"}>
                  Branding
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/contact-us"}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg ftco-navbar-light" id="mainNav">
        <div className="container-xl p-4 p-lg-0 p-xl-0">
          <button
            className="navbar-toggler"
            type="button"
            id="navToggler"
            data-bs-toggle="collapse"
            data-bs-target="#navMenu"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="fa fa-bars" /> Menu
          </button>
          <div
            className="shadow collapse navbar-collapse bg-white p-2"
            id="navMenu"
          >
            <img
              src="assets/images/msq_logo.png"
              alt="MenteSquare Logo"
              id="navLogo"
              className="d-none"
              width="10%"
            />
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to={"/home"}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/LDInterventions"}>
                  OD Interventions
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/gyaan-guides"}>
                  Gyaan Guides
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/MentoringPage"}>
                  Mentoring
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/BrandingPage"}>
                  Branding
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/contact-us"}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
